var SCAAFFCustomerReferSetting = {
    "program": {
        "active": false,
        "shop": "sungrubbies2.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "10.00",
            "price_rule_id": "",
            "coupon": ""
        },
        "program": "OTE5NzI="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Refer & Earn",
            "refer_background_color": "#000000",
            "refer_text_color": "#ffffff",
            "web_position": "right-bottom",
            "mobile_position": "right-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Invite & Get 10% from friend's orders",
            "popup_description": "Send your friends a 10% discount off their purchase. Once they make a purchase, you\u2019ll earn 10% for each order as well! This reward can be redeemed for coupons.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#000000",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You got 10% Off",
            "shop_description": "Congrats! Your friend has gifted you a coupon. Coupon will be automatically applied at the checkout page.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#000000",
            "shop_text_color": "#ffffff"
        }
    }
}